import createClient, { Middleware } from "openapi-fetch";

import { components, paths } from "./generated/generated-api";
import { process, saveMiddlewareConfiguration } from "am-tax-fe-core";

let configured = false;
let currentClient = createClient<paths, "application/json">({ baseUrl: "" });

export function configureApiClient(baseUrl: string, middlewares?: Middleware[]) {
    saveMiddlewareConfiguration(middlewares);
    currentClient = createClient<paths, "application/json">({ baseUrl:`${baseUrl}/api` });
    if (middlewares) {
        currentClient.use(...middlewares);
    }
    configured = true;
}

export function client() {
    if (!configured) {
        throw new Error("You must call configureApiClient before making any api calls");
    }
    return currentClient;
}

export const getClients = async (): Promise<Client[]> => process(client().GET("/clients"));
export type Client = components["schemas"]["saveClientResponseDto"];

export const answerQuestion = async (
    args: AnswerQuestionArgs,
) : Promise<AnswerQuestionResponse> => {
    return process(
        client().POST("/surveys/{surveyId}/answers", {
            params: {
                path: { surveyId: args.surveyId }
            },
            body: args
        })
    );
};

export const saveConclusion = async (
    args: SaveConclusionArgs,
): Promise<SaveConclusionResponse> => {
    return process(
        client().POST("/surveys/{surveyId}/conclusions", {
            params: { path: { surveyId: args.surveyId} },
            body: args,
        })
    );
};

export const submitSurvey = async (
    args: SubmitSurveyArgs,
): Promise<SubmitSurveyResponse> => {
    return process(
        client().POST("/surveys/{surveyId}", {
            params: { path: { surveyId: args.surveyId} }
        })
    );
};

export const getAnswers = async (
    args: GetAnswersArgs
): Promise<GetAnswersResponse> => {
    return process(
        client().GET("/surveys/{surveyId}/answers", {
            params: { 
                path: { surveyId: args.surveyId }
            }
        })
    );
};

export const getSurvey = async (): Promise<GetSurveyResponse> => {
    return process(
        client().GET("/survey")
    );
}

export const getConclusions = async (
    args: GetConclusionsArgs
): Promise<GetConclusionsResponse> => {
    return process(
        client().GET("/surveys/{surveyId}/conclusions", {
            params: {
                path: { surveyId: args.surveyId }
            }
        })
    );
}

export type AnswerQuestionArgs = AnswerQuestionRequest & { surveyId: string };
export type AnswerQuestionResponse = components["schemas"]["answerQuestionResponseDto"];
export type AnswerQuestionRequest = components["schemas"]["answerQuestionRequestDto"];

export type SaveConclusionArgs = SaveConclusionRequest & { surveyId: string };
export type SaveConclusionResponse = components["schemas"]["saveConclusionResponseDto"];
export type SaveConclusionRequest = components["schemas"]["saveConclusionRequestDto"];

export type SubmitSurveyArgs = { surveyId: string };
export type SubmitSurveyResponse = components["schemas"]["submitSurveyResponseDto"];

export type GetAnswersArgs = { surveyId: string };
export type GetAnswersResponse = components["schemas"]["getAnswersResponseDto"];
export type Answer = components["schemas"]["answerDto"];

export type GetSurveyResponse = components["schemas"]["surveyDto"];

export type GetConclusionsArgs = { surveyId: string };
export type GetConclusionsResponse = components["schemas"]["getConclusionsResponseDto"];
export type Conclusion = components["schemas"]["conclusionDto"];
export type ConclusionResponseDto = components["schemas"]["conclusionResponseDto"]; //TODO: Temporary data model until we figure out how to include enum as strings in openAI